import { Component, OnInit, Input, ViewChildren, QueryList, ElementRef, ContentChildren, ViewChild, Directive, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { LtbManualFormComponent } from 'src/app/ltb-usage/ltb-manual-form/ltb-manual-form.component';

@Component({
  selector: 'slide-out',
  templateUrl: './slide-out.component.html',
  styleUrls: ['./slide-out.component.scss']
})
export class SlideOutComponent implements OnInit {

  readonly elementRef: ElementRef<HTMLElement>;
  public isShown: boolean;
  public formInputs: NodeListOf<HTMLInputElement>;

  @Output() onClose = new EventEmitter();

  constructor(private elRef:ElementRef) {
    this.elementRef = elRef;
  }

  ngOnInit() {
    this.formInputs = this.elementRef.nativeElement.querySelectorAll("input");
  }

  public hide() {
    this.onClose.emit("closed");
    this.isShown = false;
  }

  public show() {
    this.isShown = true;
    if(this.isShown && this.formInputs && this.formInputs.length) {
      this.formInputs.item(0).focus();
    }
  }
}

